module.exports = __webpack_public_path__ + "static/media/29FUNOV9.638a49c1.jpg";